import {http} from '@/helpers/http-helper';

export const deleteQueryIssue = (uuid) => {
    return new Promise( (resolve, reject) => {
        const url = 'queries/issues/' + uuid;
        http.delete(url)
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                }
                else {
                    reject(response.status);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });
};